import Vue from 'vue'
import Router from 'vue-router'
import About from '@/components/About'
import Contact from '@/components/Contact'
import Current from '@/components/Current'
import Home from '@/components/Home'
import LastTenFilms from '@/components/LastTenFilms'
import PageNotFound from '@/components/PageNotFound'
import Resume from '@/components/Resume'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/current',
      name: 'Current',
      component: Current
    },
    {
      path: '/last-ten-films',
      name: 'Last Ten Films',
      component: LastTenFilms,
      props: {
        listId: '22968',
        apiKey: '5e64db8b06cd51dc071b2933504a37c8'
      }
    },
    {
      path: '/resume',
      name: 'Resume',
      component: Resume
    },
    {
      path: '*',
      name: 'Page Not Found',
      component: PageNotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js